export const getPrices = async (accessToken, url) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}api/${url}`, {
        method: "GET",
        headers: {
            "Accept": "application/json",
            "Authorization": `Bearer ${accessToken}`
        },
    })
    if (!response.ok) {
        throw new Error("Wystąpił błąd!")
    }
    const data = await response.json()

    return data;
}
export const getTotalPrices = async (accessToken, gateType) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}api/pricings?itemsPerPage=0&gateType=${gateType}`, {
        method: "GET",
        headers: {
            "Accept": "application/ld+json",
            "Authorization": `Bearer ${accessToken}`
        },
    })
    if (!response.ok) {
        throw new Error("Wystąpił błąd!")
    }
    const data = await response.json()

    return data['hydra:totalItems'];
}

export const updatePrice = async ({accessToken, data}) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}api/pricings`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${accessToken}`
        }
    })

    return response.json()
}

export const updatePriceById = async ({accessToken, data, id}) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}api/pricings/${id}/price`, {
        method: "PATCH",
        body: JSON.stringify(data),
        headers: {
            "Content-Type": "application/merge-patch+json",
            "Authorization": `Bearer ${accessToken}`
        }
    })

    return response.json()
}
export const updateRangeById = async ({accessToken, items,newMinWidthValue,newMaxWidthValue,newMinHeightValue,newMaxHeightValue }) => {
    await Promise.all(items.map(item => fetch(`${process.env.REACT_APP_API_URL}api/pricings/${item.id}/dimensions`, {
        method: "PATCH",
        body: JSON.stringify({
            minWidth: newMinWidthValue ? newMinWidthValue : item.minWidth.id,
            maxWidth: newMaxWidthValue ? newMaxWidthValue : item.maxWidth.id,
            minHeight:  newMinHeightValue ? newMinHeightValue : item.minHeight.id,
            maxHeight:  newMaxHeightValue ? newMaxHeightValue : item.minHeight.id,
        }),
        headers: {
            "Content-Type": "application/merge-patch+json",
            "Authorization": `Bearer ${accessToken}`
        }
    })))
}

export const deletePriceById = async ({accessToken, ids}) => {
    await Promise.all(ids.map(id => fetch(`${process.env.REACT_APP_API_URL}api/pricings/${id}`, {
        method: "DELETE",
        headers: {
            "Authorization": `Bearer ${accessToken}`
        }
    })))
}


export const exportPricings = async (
  accessToken,
  gateTypeId,
  fallbackName = "pricings-export"
) => {
  const url = new URL(`${process.env.REACT_APP_API_URL}api/pricings/export`);
  if (gateTypeId) url.searchParams.set("gateTypeId", gateTypeId);

  const response = await fetch(url.toString(), {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${accessToken}`,
    },
  });

  if (!response.ok) {
    let message = "Nie udało się wyeksportować danych.";
    try {
      const err = await response.json();
      if (err?.message) message = err.message;
      if (err?.detail) message = err.detail;
    } catch {}
    throw new Error(message);
  }

  const disposition = response.headers.get("Content-Disposition") || "";
  let filename = null;
  const fnStar = disposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
  const fnStd  = disposition.match(/filename\s*=\s*"?([^";]+)"?/i);
  if (fnStar?.[1]) {
    try { filename = decodeURIComponent(fnStar[1]); } catch { filename = fnStar[1]; }
  } else if (fnStd?.[1]) {
    filename = fnStd[1];
  }

  const blob = await response.blob();

  if (!filename) {
    const mime = blob.type || "";
    const ext =
      (mime.includes("csv") && ".csv") ||
      (mime.includes("sheet") && ".xlsx") ||
      (mime.includes("excel") && ".xlsx") ||
      ".bin";
    const suffix = gateTypeId ? `-${gateTypeId}` : "";
    filename = `${fallbackName}${suffix}${ext}`;
  }

  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(blobUrl);

  return true;
};


export const importPricings = async (accessToken, file, { gateTypeId, overwrite } = {}) => {
  const form = new FormData();
  form.append("file", file);
  if (gateTypeId) form.append("gateTypeId", gateTypeId);
  if (overwrite !== undefined) form.append("overwrite", String(overwrite));

  const res = await fetch(`${process.env.REACT_APP_API_URL}api/pricings/import`, {
    method: "POST",
    body: form,
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Accept": "application/json",
    },
  });

  if (!res.ok) {
    let msg = "Nie udało się zaimportować danych.";
    try {
      const err = await res.json();
      if (err?.detail) msg = err.detail;
      else if (err?.message) msg = err.message;
    } catch {}
    throw new Error(msg);
  }

  return res.json();
};

